// extracted by mini-css-extract-plugin
export default {"post":"Post_post__U3UN4","title":"Post_title__Azydc"};